import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../networking/client';
import { RootState } from '../store';
import { toast } from 'react-toastify';

export interface SamplesTakenState {
  editingStatus: string;
}

const initialState: SamplesTakenState = {
  editingStatus: 'idle',
};

type EditSampleTaken = {
  sampleBarcode: string;
  sampleTakenId: number;
};

export const editSampleTaken = createAsyncThunk(
  'sample-taken/edit',
  async (editSampleTaken: EditSampleTaken, { dispatch, rejectWithValue }) => {
    try {
      await client.put(`/healthpoint/sample-taken/${editSampleTaken.sampleTakenId}`, {
        sampleBarcode: editSampleTaken.sampleBarcode,
      });
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const samplesTakenSlice = createSlice({
  name: 'samplesTaken',
  initialState,
  reducers: {
    resetSamplesTaken: (_) => {
      return initialState;
    },
    resetEditingStatus: (state) => {
      return {
        ...state,
        editingStatus: 'idle',
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(editSampleTaken.pending, (state) => {
        state.editingStatus = 'pending';
      })
      .addCase(editSampleTaken.fulfilled, (state) => {
        toast.success('Successfully updated sample barcode.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        state.editingStatus = 'fulfilled';
      })
      .addCase(editSampleTaken.rejected, (state, action: any) => {
        // toast.error(action?.payload?.error ?? 'Something went wrong.', {
        //   position: toast.POSITION.BOTTOM_RIGHT,
        // });
        state.editingStatus = 'rejected';
      });
  },
});

export const { resetSamplesTaken, resetEditingStatus } = samplesTakenSlice.actions;

export default samplesTakenSlice.reducer;

export const selectSamplesTakenEditingStatus = (state: RootState) =>
  state.samplesTaken.editingStatus;
